import { Button, Checkbox, DataHeader, DataSource, Label, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPnnControlsTransmit extends Layout {
    buttonOpenClassic: Button;
    buttonSendAvailableEmail: Button;
    checkboxLoadboardAllowOffers: Checkbox;
    checkboxNonBrokered: Checkbox;
    dataheaderTitle: DataHeader;
    labelDaysAfter: Label;
    labelPrior: Label;
    labelS: Label;
    panelComment: Panel;
    panelEmail2: Panel;
    panelEmail: Panel;
    panelLoadSchedule: Panel;
    panelRevenueCodes: Panel;
    panelUnsubscribe: Panel;
    sourceEmailControl: DataSource;
    sourcePnnControl: DataSource;
    sourcePnnLoadSched: DataSource;
    sourcePnnRevcode: DataSource;
    switchAllRevenueCode: Switch;
    tabAllowOffers: Tab;
    tabDefaultSchedules: Tab;
    tabMain: Tab;
    tabRevenueCodes: Tab;
    tableLoadSchedules: Table;
    tableRevenueCodes: Table;
    tabsetPnn: Tabset;
    textboxAt: Textbox;
    textboxAtUnsubscribe: Textbox;
    textboxComment: Textbox;
    textboxEmailProfile: Textbox;
    textboxErrorEmail: Textbox;
    textboxOrderComment: Textbox;
    textboxOrderReplyTo: Textbox;
    textboxPrior: Textbox;
    textboxQualificationStatus: Textbox;
    textboxReplyTo: Textbox;
    textboxSelectLoads: Textbox;
    textboxUnsubscribeContact: Textbox;
    textboxVia: Textbox;
    textboxViaContact: Textbox;
}
